// src/data/chartOfAccounts.js
export const chartOfAccounts = [
  {
    id: 1000,
    code: "1000",
    name: "Cash",
    type: "Asset",
    description: "Cash on hand and in bank accounts"
  },
  {
    id: 1100,
    code: "1100",
    name: "Accounts Receivable",
    type: "Asset",
    description: "Amounts owed by students and others"
  },
  {
    id: 1200,
    code: "1200",
    name: "Prepaid Expenses",
    type: "Asset",
    description: "Expenses paid in advance"
  },
  {
    id: 2000,
    code: "2000",
    name: "Accounts Payable",
    type: "Liability",
    description: "Amounts owed to suppliers and vendors"
  },
  {
    id: 2100,
    code: "2100",
    name: "Accrued Expenses",
    type: "Liability",
    description: "Expenses incurred but not yet paid"
  },
  {
    id: 3000,
    code: "3000",
    name: "Tuition Revenue",
    type: "Revenue",
    description: "Income from tuition fees"
  },
  {
    id: 3100,
    code: "3100",
    name: "Miscellaneous Revenue",
    type: "Revenue",
    description: "Other income sources"
  },
  {
    id: 4000,
    code: "4000",
    name: "Salaries Expense",
    type: "Expense",
    description: "Employee salaries and wages"
  },
  {
    id: 4110,
    code: "4110",
    name: "Employee Benefits",
    type: "Expense",
    description: "SSS, PhilHealth, Pag‑IBIG, allowances"
  },
  {
    id: 4210,
    code: "4210",
    name: "Internet and Communications",
    type: "Expense",
    description: "Internet plans, phone, SMS"
  },
  {
    id: 4300,
    code: "4300",
    name: "Rent",
    type: "Expense",
    description: "Building and room rentals"
  },
  {
    id: 4310,
    code: "4310",
    name: "Repairs and Maintenance",
    type: "Expense",
    description: "Facilities and equipment maintenance"
  },
  {
    id: 4320,
    code: "4320",
    name: "Depreciation",
    type: "Expense",
    description: "Depreciation of fixed assets"
  },
  {
    id: 4340,
    code: "4340",
    name: "Professional Fees",
    type: "Expense",
    description: "Legal, audit, consulting"
  },
  {
    id: 4350,
    code: "4350",
    name: "Bank Charges",
    type: "Expense",
    description: "Service fees and charges"
  },
  {
    id: 4360,
    code: "4360",
    name: "Transportation",
    type: "Expense",
    description: "Travel and transport costs"
  },
  {
    id: 4370,
    code: "4370",
    name: "Printing and Reproduction",
    type: "Expense",
    description: "Forms, IDs, documents"
  },
  {
    id: 4380,
    code: "4380",
    name: "Training and Seminars",
    type: "Expense",
    description: "Staff development"
  },
  {
    id: 4390,
    code: "4390",
    name: "Security Services",
    type: "Expense",
    description: "Security personnel and services"
  },
  {
    id: 4400,
    code: "4400",
    name: "Cleaning Services",
    type: "Expense",
    description: "Janitorial services and supplies"
  },
  {
    id: 4410,
    code: "4410",
    name: "Insurance",
    type: "Expense",
    description: "Property and staff insurance"
  },
  {
    id: 4420,
    code: "4420",
    name: "Taxes and Licenses",
    type: "Expense",
    description: "Permits, licenses, and taxes"
  },
  {
    id: 4100,
    code: "4100",
    name: "Supplies Expense",
    type: "Expense",
    description: "Office and school supplies"
  },
  {
    id: 4200,
    code: "4200",
    name: "Utilities Expense",
    type: "Expense",
    description: "Electricity, water, and other utilities"
  }
];
